export default __webpack_public_path__ + "img/winter-has-come.webp";